export const managerRole = 'manager'
export const regularUserRole = 'regular'
